import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class FinanceGroupsApi extends ApiModule {
  constructor() {
	super(ModulesMap.FINANCE_GROUPS, {
	  entity: 'finance_groups',
	})
  }
}
